var _circle, _path, _path2, _path3, _path4, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F600(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDD67",
    cx: 32,
    cy: 32,
    r: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M49.695 34.436c-.406-.52-1.127-.43-1.912-.43H16.215c-.785 0-1.505-.09-1.912.43C10.393 39.422 14.993 54 31.999 54c17.007 0 21.606-14.578 17.696-19.564z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C3526",
    d: "M33.842 41.741c-.578-.014-1.47.526-1.144 1.957.163.723 1.19 1.597 1.19 2.763 0 2.372-3.777 2.372-3.777 0 0-1.166 1.025-2.04 1.19-2.763.326-1.431-.565-1.971-1.145-1.957-1.571.041-4.149 1.736-4.149 4.604 0 3.224 2.684 5.836 5.992 5.836 3.307 0 5.99-2.612 5.99-5.836.001-2.867-2.577-4.563-4.147-4.604z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF717F",
    d: "M24.287 50.665c2.229.956 4.8 1.517 7.713 1.517 2.914 0 5.484-.561 7.713-1.517-2.15-1.032-4.711-1.663-7.713-1.663s-5.561.631-7.713 1.663z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M46.953 36H17.046c-2.053 0-2.053 4-.053 4h30.012c2.001 0 2.001-4-.052-4z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#664E27",
    cx: 20.5,
    cy: 23,
    r: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#664E27",
    cx: 43.5,
    cy: 23,
    r: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F600);
export default __webpack_public_path__ + "static/media/1f600.f4d276e8ff64b6db92769a37b2067c50.svg";
export { ForwardRef as ReactComponent };